import * as THREE from 'three';
import { Renderer } from "./Renderer";
import { Request } from "./Request";
import { Env } from "./Env";

export class JPG {

    static async export(factor = 1) {
        let canvas = new OffscreenCanvas(Env.canvas_size.width, Env.canvas_size.height);
        const renderer = Renderer.setRenderer(canvas, factor);

        canvas.getContext('webgl');
        let blob = await canvas.convertToBlob();
        renderer.renderLists.dispose()
        renderer.dispose();
        return blob;
        /** in PHP:
        * <?php
        *    $aaa = explode(",", $_POST['pngData']);
        *    file_put_contents("invoicedata.png", base64_decode($aaa[1]));
        * ?>
        */
    }

    static async fetch(url: string, callback = false, error = false) {
        try {
            const jpg = await JPG.export();
            const response = await Request.send(url, { image: jpg });
            const json = await response.json();
            if (json.success !== 'ok') {
                if (error) {
                    return { success: json.success, error };
                } else {
                    return { success: json.success };
                }
            } else {
                if (callback) {
                    return { success: json.success, callback };
                }
            }
        } catch (e) {
        }
    }

    static async setImageBitmaps() {
        const jpg_url = {};
        const promiseAll: any[] = [];
        async function setImage(url: string) {
            return new Promise(async function (resolve, reject) {
                if ( !THREE.Cache.get(url) ) {
                    let image: ImageBitmap, download: Response;
                    try {
                        download = await fetch(url);
                        if (download.status === 404 || download.status === 403) throw 'brak obrazka';
                    } catch (e) {
                        try {
                            download = await fetch(url);
                            if (download.status === 404 || download.status === 403) throw 'brak obrazka';
                        } catch (e) {
                            download = await fetch(`${Env.base_url}static/corps/default.png`);
                        }
                    }
                    const blob = await download.blob()
                    image = await createImageBitmap(blob);
                    THREE.Cache.add(url, image);
                    resolve(true);
                } else resolve(true);
            })
        }
        function setImageBitmapUrls(panels_position) {
            const urls = [`${Env.base_url}static/corps/obrzeze_brak.jpg`, `${Env.base_url}static/corps/matcaps_metal.jpg`, `${Env.base_url}static/corps/default.png`, `${Env.base_url}static/corps/matcaps_black_ball.jpg`, `${Env.base_url}static/corps/roundshadow.png`, /*`${Env.base_url}static/corps/floor.jpg`,*/ `${Env.base_url}static/corps/wall.jpg`, `${Env.base_url}static/corps/sky.jpg`, `${Env.base_url}static/corps/floor_wood4.jpg`, `${Env.base_url}static/corps/floor_wood4_normal.jpg`, `${Env.base_url}static/corps/1817.jpg`,/*`${Env.base_url}/static/corps/wall_plaster.jpg`, `${Env.base_url}/static/corps/wall_plaster_normal.jpg`*/];
            for (const index in panels_position.materials) {
                if (panels_position.materials[index]?.data.image_exist) {
                    urls.push(panels_position.materials[index]?.data.image_big)
                }
            }
            for (const index in panels_position.veneers) {
                if (panels_position.veneers[index]?.data.image_exist) {
                    urls.push(panels_position.veneers[index]?.data.image_big);
                }
            }
            return urls;
        }

        if (Env.cabinets_cart_data) {
            for (const index in Env.cabinets_cart_data) {
                for (const url of setImageBitmapUrls(Env.cabinets_cart_data[index])) {
                    if (!jpg_url[url]) {
                        jpg_url[url] = true;
                        promiseAll.push(setImage(url));
                    }
                }
            }
        } else {
            for (const url of setImageBitmapUrls(Env.panels_position)) {
                if (!jpg_url[url]) {
                    jpg_url[url] = true;
                    promiseAll.push(setImage(url));
                }
            }
        }
        return Promise.all(promiseAll);
    }

}